import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import Who from '../../Who';
import { UserRelationType } from '../../Who/redux/types';
import { isSimpleDeviation } from '../../DeviationViews/_helpers';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import { usePopoverOnInteraction } from '@wix/da-ds/pkg/popper/hooks/usePopoverOnInteraction';
import type { OffsetModifier } from '@wix/da-ds/pkg/popper/types';

const offsetModifier: OffsetModifier = [0, 0];

import s from './WhoTooltipWrapper.scss';

export interface Props {
  deviation: PapiDeviation;
  userListType: UserRelationType;
  className?: string;
}

const WhoTooltipWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  userListType,
  className,
  children,
}) => {
  const { isVisible, onMouseEnter, onMouseLeave } = usePopoverOnInteraction({
    listenOnHover: true,
    hideOnScroll: false,
  });

  const noHover = isSimpleDeviation(deviation);

  if (noHover) {
    return <span className={classnames(s['tooltip-wrapper'], className)}>{children}</span>;
  }

  return (
    <span
      className={classnames(s['root'], className)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <PositionOnlyPopperPopover
        isVisible={isVisible}
        popoverContent={<Who deviation={deviation} userListType={userListType} />}
        directionalClassNames={{
          top: s['tooltip-top'],
          bottom: s['tooltip-bottom'],
        }}
        wrapperClassName={s['tooltip-wrapper']}
        offsetModifier={offsetModifier}
        usePortal={false}
      >
        {children}
      </PositionOnlyPopperPopover>
    </span>
  );
};
WhoTooltipWrapper.displayName = 'WhoTooltipWrapper';

export default WhoTooltipWrapper;
